/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestVotiumMultiMerkleStash extends Contract<ITestVotiumMultiMerkleStash> {
  owner: Call<() => string, ITestVotiumMultiMerkleStash>
  'owner()': Call<() => string, ITestVotiumMultiMerkleStash>
  updateMerkleRoot: Send<(_token: AddressLike, _merkleRoot: BytesLike) => void, ITestVotiumMultiMerkleStash>
  'updateMerkleRoot(address,bytes32)': Send<(_token: AddressLike, _merkleRoot: BytesLike) => void, ITestVotiumMultiMerkleStash>
}

let ITestVotiumMultiMerkleStashBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestVotiumMultiMerkleStashBytecode = '0x';
}

// prettier-ignore
export const ITestVotiumMultiMerkleStash = contract<ITestVotiumMultiMerkleStash>(ITestVotiumMultiMerkleStashBytecode)`
  function owner() view returns (address owner_)
  function updateMerkleRoot(address _token, bytes32 _merkleRoot)
`;